/* unplugin-vue-components disabled */import { render } from "./volume.vue?vue&type=template&id=36d882f7&scoped=true&ts=true"
import script from "./volume.vue?vue&type=script&lang=ts"
export * from "./volume.vue?vue&type=script&lang=ts"

import "./volume.vue?vue&type=style&index=0&id=36d882f7&lang=scss&scoped=true"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d882f7"],['__file',"src/baseui/player/volume.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "36d882f7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36d882f7', __exports__)) {
    console.log('reload')
    api.reload('36d882f7', __exports__)
  }
  
  module.hot.accept("./volume.vue?vue&type=template&id=36d882f7&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('36d882f7', render)
  })

}


export default __exports__